import { render, staticRenderFns } from "./ClusterGrid.vue?vue&type=template&id=19672650&scoped=true"
import script from "./ClusterGrid.vue?vue&type=script&lang=ts"
export * from "./ClusterGrid.vue?vue&type=script&lang=ts"
import style0 from "./ClusterGrid.vue?vue&type=style&index=0&id=19672650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19672650",
  null
  
)

export default component.exports